import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Mariana G.',
    city: 'Guadalajara, México',
    title: 'Dejé de acostarme con miedo al silencio.',
    text: 'Lo que más me ayudó fue tener algo concreto que hacer cuando el zumbido aparecía. No sentí que fuera una promesa exagerada. Fue una rutina simple que me ayudó a calmarme, dejar de enfocarme tanto en el sonido y dormir con más tranquilidad.',
    avatar: 'https://ui-avatars.com/api/?name=Mariana+G&background=F6C65B&color=070B16&size=128&rounded=true'
  }, {
    name: 'José Luis R.',
    city: 'Monterrey, México',
    title: 'Por fin entendí que no tenía que pelear contra el ruido.',
    text: 'Yo usaba ruido blanco casi todas las noches. A veces ayudaba, pero cuando lo apagaba volvía la ansiedad. Este protocolo me dio otra forma de responder. Me gustó porque trabaja con la atención y la calma, no con falsas promesas.',
    avatar: 'https://ui-avatars.com/api/?name=Jose+Luis&background=F6C65B&color=070B16&size=128&rounded=true'
  }, {
    name: 'Claudia M.',
    city: 'Ciudad de México',
    title: 'La técnica de emergencia me sirvió en mis peores noches.',
    text: 'Había noches en las que empezaba a revisar si el zumbido seguía ahí y eso me desesperaba más. La técnica me ayudó a romper ese ciclo. No desapareció mágicamente, pero sentí que ya no me dominaba igual.',
    avatar: 'https://ui-avatars.com/api/?name=Claudia+M&background=F6C65B&color=070B16&size=128&rounded=true'
  }];
  return <section className="py-16 md:py-24 px-5 md:px-8" data-id="element-263">
      <div className="max-w-6xl mx-auto" data-id="element-264">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-265">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-266">
            Personas que buscaban noches más tranquilas
          </h2>
          <p className="text-lg text-gray-400 max-w-3xl mx-auto" data-id="element-267">
            No promete magia. No promete curar tinnitus. Solo una rutina clara
            para calmar la reacción mental al zumbido y recuperar más control
            por la noche.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-268">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.2
        }} className="bg-[#0B1224] p-8 rounded-2xl border border-[#15203B] flex flex-col h-full relative" data-id="element-269">
              <div className="flex items-center gap-4 mb-6" data-id="element-270">
                <img src={t.avatar} alt={t.name} className="w-14 h-14 rounded-full border-2 border-[#F6C65B]" loading="lazy" decoding="async" width="56" height="56" data-id="element-271" />
                <div data-id="element-272">
                  <p className="text-white font-bold" data-id="element-273">{t.name}</p>
                  <p className="text-gray-500 text-sm" data-id="element-274">{t.city}</p>
                </div>
              </div>
              <div className="mb-4" data-id="element-275">
                <span className="inline-block bg-[#F6C65B]/10 text-[#F6C65B] text-xs font-bold px-3 py-1 rounded-full border border-[#F6C65B]/30" data-id="element-276">
                  Testimonio representativo
                </span>
              </div>
              <h3 className="text-[#F6C65B] font-bold text-lg mb-3" data-id="element-277">
                "{t.title}"
              </h3>
              <p className="text-gray-300 leading-relaxed flex-grow" data-id="element-278">
                {t.text}
              </p>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-279">
          <p className="text-gray-500 text-xs max-w-2xl mx-auto" data-id="element-280">
            Los testimonios son representativos de experiencias de usuarios. Los
            resultados pueden variar. Este protocolo no diagnostica, trata ni
            cura tinnitus u otra condición médica.
          </p>
        </div>
      </div>
    </section>;
}